import * as React from 'react';
import SunWorldLoading from 'app/assets/img/sunworld-loading.svg';
import { cn } from '@/lib/utils';

export interface LoadingProps {
  loading?: boolean;
  children?: React.ReactNode;
  className?: string;
  contentClassName?: string;
  minHeight?: string;
  maxWidth?: string | number;
}

export function Loading({
  loading,
  children,
  className,
  contentClassName,
  minHeight,
  maxWidth,
}: LoadingProps) {
  return (
    <div
      className={cn(
        'relative min-w-0',
        loading && 'min-h-[inherit]',
        className,
      )}
      style={minHeight ? { minHeight } : undefined}
    >
      <div
        className={cn(
          loading && 'pointer-events-none opacity-50',
          contentClassName,
        )}
      >
        {children}
      </div>
      {loading ? (
        <div className="absolute inset-0 z-10 flex items-center justify-center rounded-[inherit] bg-white/70">
          <img
            src={SunWorldLoading}
            alt="Loading"
            className="h-auto w-[120px] opacity-70"
            style={maxWidth ? { maxWidth } : undefined}
          />
        </div>
      ) : null}
    </div>
  );
}

export default Loading;
